import { DescriptionParser } from '@/app_lib/htmlParser/ContentParser';
import type { Article } from '@/app_lib/types/Article';
import { AnalyticsEvent, ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

export const SubscriptionPlea = ({
  subscriptionPleaTextLined,
}: Pick<Article['postSettings'], 'subscriptionPleaTextLined'>) => {
  if (!subscriptionPleaTextLined) {
    return null;
  }

  return (
    // NOTE: the [&_*_a] is a tailwind utility to apply styles to all nested anchor tags
    <div
      className={cn(
        'typography-level-4 mt-4 font-graphik-compact [&_*_a]:hover:underline',
        AnalyticsEvent.ImpressionElement,
      )}
      data-cy={ContentPlacement.SubscriptionPlea}
    >
      <DescriptionParser content={subscriptionPleaTextLined || ''} />
    </div>
  );
};
